import React from "react";
import { Component } from "react";
import actions from "actions";
import MenuSwitch from "../../../components/Admin/StudyGroups/MenuSwitch";
import StudyGroupTitle from "../../../components/Admin/StudyGroups/StudyGroupTitle";
import { connect } from "react-redux";
import { getAdminStudygroup } from "../../../actions/studygroups";

// const getTabs = role => {
// 	switch(role) {
// 		case 'user':
// 			return ['materials', 'webinars', 'cpd', 'chat', 'members', 'notifications']
// 		case 'admin': case 'superhost':
// 			return ['materials', 'webinars', 'cpd', 'chat', 'members', 'notifications', 'faqs']
// 		default:
// 			return ['ERROR']
// 	}
// }

const getTabs = (role) => {
  switch (role) {
    case "user":
      return ["materials", "webinars", "statistics", "members"];
    case "admin":
    case "superhost":
      return ["webinars", "resources", "statistics", "members"];
    default:
      return ["ERROR"];
  }
};

class StudyGroupPage extends Component {
  constructor(props) {
    super(props);

    const tabs = getTabs(this.props.role);

    this.state = {
      tabs,
    };
  }

  componentWillMount() {
    const { loadStudyGroup, params } = this.props;

    loadStudyGroup(params.id);
  }

  render() {
    const { studygroup, params, location, children } = this.props;
    const groupId = params.id;

    return (
      <main className="site--width">
        <StudyGroupTitle title={studygroup.title || ""} />
        <MenuSwitch
          activeUrl={location.pathname}
          tabs={this.state.tabs}
          groupId={groupId}
        />
        {children}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.users.user.role,
  studygroup: state.studygroups.studygroup,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudyGroup: (id) => dispatch(getAdminStudygroup(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudyGroupPage);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/StudyGroupPage.jsx